import { severity } from "../models/severity.enum";

export class SnackbarService {
    openSnackbar: (message: string, severity: severity, duration?: number) => void;
    closeSnackbar: () => void;

    constructor(openSnackbar, closeSnackbar){
        this.openSnackbar = openSnackbar;
        this.closeSnackbar = closeSnackbar;
    }
}
